// extracted by mini-css-extract-plugin
export default {"info":"MARegSHOPage_info__Kq9sY","mdSubscription":"MARegSHOPage_mdSubscription__VsXsg","mdAdvert":"MARegSHOPage_mdAdvert__FfCLx","footerNote":"MARegSHOPage_footerNote__INI-f"};